// ----------------------------------------------------------------------------
// Component: Carousel
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------
import $ from 'jquery';
// Style includes
import './slick-carousel-custom';
import 'slick-carousel/slick/slick.scss';

const slickNext = "<button type='button' class='slick-next'><div class='icon svg--baseline'><svg class='icon icon__arrow--right'><use xlink:href='#icon-arrow--right'></use></svg></div><span class='sr-only'>Previous</span></button>";
const slickPrev = "<button type='button' class='slick-prev'><div class='icon svg--baseline'><svg class='icon icon__arrow--left'><use xlink:href='#icon-arrow--left'></use></svg></div><span class='sr-only'>Next</span</button>";

// -------------------------------------
// Carousels -- Collection Scripts
// -------------------------------------
function getTransform(el) {
    var results = $(el).css('-webkit-transform').match(/matrix(?:(3d)\(-{0,1}\d+(?:, -{0,1}\d+)*(?:, (-{0,1}\d+))(?:, (-{0,1}\d+))(?:, (-{0,1}\d+)), -{0,1}\d+\)|\(-{0,1}\d+(?:, -{0,1}\d+)*(?:, (-{0,1}\d+))(?:, (-{0,1}\d+))\))/);

    if(!results) return [0, 0, 0];
    if(results[1] == '3d') return results.slice(2,5);

    results.push(0);
    return results.slice(5, 8);
}

var curPercentage = 0,
	barPercentage = 0,
	restPercentage = 0,
	percentage,
	bar;

$('#carousel-collection')
	.on('init breakpoint', function(event, slick) {
		var slickActiveWidth = 0;
		var slickTrack = $(this).find('.slick-track');
		var slideCount = slick.slideCount;
		var slidesToShow = slick.options.slidesToShow;
		bar = $(this).parents('.carousel-container').find('.bar');
    	$(this).find('.slick-active').each(function(){
    		slickActiveWidth = slickActiveWidth + $(this).width();
    	})
    	barPercentage = slickActiveWidth/slickTrack.width()*100;
    	restPercentage = 100 - barPercentage;
    	percentage = restPercentage/(slideCount - slidesToShow);
    	bar.css("width", ""+barPercentage+"%");
	})
	.on('beforeChange', function(event, slick, currentSlide, nextSlide){
		bar.removeClass('bar--no-transition');
		if (currentSlide === 0 && nextSlide === slick.slideCount - 1) {
		    // its going from the first slide to the last slide (backwards)
		    var direction = 'prev';
		} else if (nextSlide > currentSlide || (currentSlide === (slick.slideCount - 1) && nextSlide === 0 )) {
		    // its either going normally forwards or going from the last slide to the first
		    var direction = 'next';
		} else {
		    var direction = 'prev';
		}

		if( direction == 'next' ){

			if (slick.$slides.length < currentSlide + slick.options.slidesToShow) {
				curPercentage = restPercentage;
		    }else{
		    	curPercentage = curPercentage + percentage;
		    }
			
		}else if( direction == 'prev' ){
			if( currentSlide - 1 == 0 ) {
				curPercentage = 0;
			}else {
				curPercentage = curPercentage - percentage;
			}

		}

		bar.css('left', ""+curPercentage+"%");
	})
	.on('afterChange', function(event, slick, currentSlide){
		if( currentSlide == 0 ) {
			curPercentage = 0;
		}else {
			if (slick.slideCount <= currentSlide + slick.options.slidesToShow) {
				curPercentage = restPercentage;
		    }
		}
		bar.css('left', ""+curPercentage+"%");
})


// Event to initiate drag, include touchstart events
$('#carousel-collection').on('mousedown', function(e){

	var bar = $(this).parents('.carousel-container').find('.bar');
	
	bar.addClass('bar--no-transition');

	$(this).one('mouseup', function(e){
		bar.removeClass('bar--no-transition');
		$(this).off('mousemove');
		var currentSlide = $(this).find('.slick-current');
		if( currentSlide.attr('data-slick-index') == '0' ) {
			curPercentage = 0;
		}else {
			if ($(this).find('.slick-slide').length <= currentSlide + $(this).find('.slide-active')) {
		        curPercentage = restPercentage;
		    }
		}

		bar.css('left', ""+curPercentage+"%");
	}).on('mousemove', function(e){

		var slickTrack = $(this).find('.slick-track');
	    var slickTrackTransform = getTransform(slickTrack);
	    var slickTrackWidth = slickTrack.width();
	    var percentage1 = Math.abs(slickTrackTransform[0]/slickTrackWidth*100);
	    bar.css('left', ""+percentage1+"%");
	});

});


// -------------------------------------
// Influencer Testimonial Carousel
// -------------------------------------

$('#influencer-carousel')
	.on('init breakpoint', function(event, slick) {
		var slickActiveWidth = 0;
		var slickTrack = $(this).find('.slick-track');
		var slideCount = slick.slideCount;
		var slidesToShow = slick.options.slidesToShow;
		bar = $(this).parents('.carousel-container').find('.bar');
    	$(this).find('.slick-active').each(function(){
				// (true) includes margin
    		slickActiveWidth = slickActiveWidth + $(this).outerWidth(true);
    	})
    	barPercentage = slickActiveWidth/slickTrack.width()*100;
    	restPercentage = 100 - barPercentage;
    	percentage = restPercentage/(slideCount - slidesToShow);
    	bar.css("width", ""+barPercentage+"%");
	})
	.on('beforeChange', function(event, slick, currentSlide, nextSlide){
		bar.removeClass('bar--no-transition');
		if (currentSlide === 0 && nextSlide === slick.slideCount - 1) {
		    // its going from the first slide to the last slide (backwards)
		    var direction = 'prev';
		} else if (nextSlide > currentSlide || (currentSlide === (slick.slideCount - 1) && nextSlide === 0 )) {
		    // its either going normally forwards or going from the last slide to the first
		    var direction = 'next';
		} else {
		    var direction = 'prev';
		}

		if( direction == 'next' ){

			if (slick.$slides.length < currentSlide + slick.options.slidesToShow) {
				curPercentage = restPercentage;
		    }else{
		    	curPercentage = curPercentage + percentage;
		    }
			
		}else if( direction == 'prev' ){

			if( currentSlide - 1 == 0 ) {
				curPercentage = 0;
			}else {
				curPercentage = curPercentage - percentage;
			}

		}

		bar.css('left', ""+curPercentage+"%");
	})
	.on('afterChange', function(event, slick, currentSlide){
		if( currentSlide == 0 ) {
			curPercentage = 0;
		}else {
			if (slick.slideCount <= currentSlide + slick.options.slidesToShow) {
				curPercentage = restPercentage;
		    }
		}
		bar.css('left', ""+curPercentage+"%");
})


// Event to initiate drag, include touchstart events
$('#influencer-carousel').on('mousedown', function(e){

	var bar = $(this).parents('.carousel-container').find('.bar');
	
	bar.addClass('bar--no-transition');

	$(this).one('mouseup', function(e){
		bar.removeClass('bar--no-transition');
		$(this).off('mousemove');
		var currentSlide = $(this).find('.slick-current');
		if( currentSlide.attr('data-slick-index') == '0' ) {
			curPercentage = 0;
		}else {
			if ($(this).find('.slick-slide').length <= currentSlide + $(this).find('.slide-active')) {
		        curPercentage = restPercentage;
		    }
		}

		bar.css('left', ""+curPercentage+"%");
	}).on('mousemove', function(e){

		var slickTrack = $(this).find('.slick-track');
	    var slickTrackTransform = getTransform(slickTrack);
	    var slickTrackWidth = slickTrack.width();
	    var percentage1 = Math.abs(slickTrackTransform[0]/slickTrackWidth*100);
	    bar.css('left', ""+percentage1+"%");
	});

});


// -------------------------------------
// Carousels -- Default Scripts
// -------------------------------------

$('.carousel-container').each(function() {
    // Initialize Carousel
    $(this).find('.carousel').slick({
        nextArrow: $(this).find('.slick-next'),
        prevArrow: $(this).find('.slick-prev'),
				accessibility: false
    });
});
